import React from "react";
import { Redirect, useLocation, useParams } from "react-router";
import { useMount } from "react-use";

import { usePageTrack } from "lib/contexts/analytics";
import { UseSessionWebSocketResult } from "links/lib/features/sessions/useSessionWebSocket";
import { AnalyticsPage } from "links/lib/types";
import { JoinCode } from "sessionComponents/organisms/JoinCode";

type SessionJoinProps = {
  ws: UseSessionWebSocketResult;
};

export const SessionJoin: React.FC<SessionJoinProps> = ({
  ws,
}: SessionJoinProps) => {
  const location = useLocation() as {
    state?: { redirectToSeasonMap?: boolean };
    search?: string;
  };
  let redirectToSeasonMap = location.state?.redirectToSeasonMap;
  const params = useParams<{ code?: string }>();
  const search = new URLSearchParams(location.search || "");
  if (search.get("redirectToSeasonMap") !== null) {
    redirectToSeasonMap = search.get("redirectToSeasonMap") === "true";
  }

  usePageTrack(AnalyticsPage.Session_Join);

  useMount(() => {
    if (params.code) ws.joinSession(params.code.toUpperCase());
  });

  const onJoinSession = (joinCode: string) => {
    ws.joinSession(joinCode);
  };

  if (ws.state.session) {
    return (
      <Redirect to={{ pathname: "/session", state: { redirectToSeasonMap } }} />
    );
  }

  return (
    <JoinCode
      onJoinSession={onJoinSession}
      joinCode={params.code?.toUpperCase()}
      error={ws.state.error}
      isLoading={!!params.code && !ws.state.error}
    />
  );
};
